// extracted by mini-css-extract-plugin
module.exports = {"root":"LeftColumn_root__6lRkP","futureDeliveryBlock":"LeftColumn_futureDeliveryBlock__aMlUu"};